import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import ProjectService from "../../all-projects/ProjectService";
import CreateProjectService from "../CreateProjectService";
import { Toast } from "primereact/toast";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

type AssignProps = {
  userId: any;
  onNext: () => void;
};

const AssignDevices = (props: AssignProps) => {
  const toast = useRef<any>(null);
  const { t } = useTranslation();

  const [availableDevices, setAvailableDevices] = useState<any>([]);
  const [assignedDevices, setAssignedDevices] = useState<any>([]);
  const [stationName, setStationName] = useState<string>();
  const [dialogue, setDialogue] = useState<boolean>(false);
  const [rowValue, setRowValue] = useState<any>();
  const [error, setError] = useState<any>([]);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [selectedDevices, setSelectedDevices] = useState<any>([]);
  const createProjectService = new CreateProjectService();

  const onHide = () => {
    setDialogue(false);
  };

  const deleteProjectInfo = () => {
    localStorage.removeItem("projectInfo");
    localStorage.removeItem("measurements");
    localStorage.removeItem("deviceMessaging");
    localStorage.removeItem("serverMessaging");
    localStorage.removeItem("transferInfo");
  };

  const addDevices = (rowData: any) => {
    if (stationName) {
      let isFound = false;
      assignedDevices.find((val: any, index: any) => {
        if (val.station_name === stationName) {
          isFound = true;
        }
      });
      if (isFound === false) {
        let rowIndex = availableDevices.indexOf(rowData);
        let indexValue = availableDevices.at(rowIndex);
        let previousAvailable = [...assignedDevices];
        const rows = [...availableDevices];
        rows.splice(rowIndex, 1);
        setAvailableDevices(rows);
        let arr: any;
        arr = {
          id: indexValue.id,
          did: indexValue.did,
          device_type: indexValue.device_type,
          rent_from: indexValue.rent_from,
          rent_to: indexValue.rent_to,
          station_name: stationName,
          is_checked: false,
        };
        previousAvailable.push(arr);
        setAssignedDevices(previousAvailable);
        setDialogue(false);
        setStationName("");
      } else {
        setError(t('station_name_exist'));
      }
    } else {
      setError(t('station_name_empty'));
    }
  };

  const deleteDevice = (rowData: any) => {
    let rowIndex = assignedDevices.indexOf(rowData);
    let indexValue = assignedDevices.at(rowIndex);
    let previousAvailable = [...availableDevices];
    const rows = [...assignedDevices];
    rows.splice(rowIndex, 1);
    setAssignedDevices(rows);
    let arr: any;
    arr = {
      id: indexValue.id,
      did: indexValue.did,
      device_type: indexValue.device_type,
      rent_from: indexValue.rent_from,
      rent_to: indexValue.rent_to,
    };
    previousAvailable.push(arr);
    setAvailableDevices(previousAvailable);
  };

  const showSuccess = (message: string) => {
    toast.current.show({
      severity: "success",
      summary: "Confirmation Message",
      detail: message,
      life: 3000,
    });
  };

  const buttonsTemplate = (rowData: any) => {
    return (
      <div className="p-formgroup-inline">
        <Button
          icon="pi pi-plus-circle"
          className="p-button-rounded p-button-primary p-button-text table-edit-button"
          aria-label="Add"
          tooltip="Add Device"
          onClick={() => {
            setRowValue(rowData);
            setDialogue(true);
            setError("");
          }}
        />
      </div>
    );
  };

  const buttons1Template = (rowData: any) => {
    return (
      <div className="p-formgroup-inline">
        <Button
          icon="pi pi-minus-circle"
          className="p-button-rounded p-button-primary p-button-text table-edit-button"
          aria-label="Delete"
          tooltip="Delete Device"
          onClick={() => {
            deleteDevice(rowData);
            // setRowValue(rowData);
          }}
        />
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <Button
          label={t("cancel")}
          icon="pi pi-times"
          onClick={() => onHide()}
          className="p-button-text"
        />
        <Button
          label={t("assign")}
          icon="pi pi-check"
          onClick={() => {
            if(stationName === undefined){
              setError(t('station_name_empty'));
            }
            else if(stationName){
              const specialCharPattern = /[äüß]/;
              if (specialCharPattern.test(stationName)) {
                setError(t("station_name_special_char_error"));
              }
              else{
                addDevices(rowValue)
              }
            }
          }}
          autoFocus
        />
      </div>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);

    createProjectService
      .getDeviceList(props.userId)
      .then((response) => setAvailableDevices(response));
  }, [i18n.language]);

  const handleSelectionChange = (e: any) => {
    const updatedSelection = e.value.map((device: any) => ({
      ...device,
      is_checked: true
    }));
    setSelectedDevices(updatedSelection);
  };

  useEffect(() => {
    const updatedDevices = assignedDevices.map((device: any) => ({
      ...device,
      is_checked: selectedDevices.some((selectedDevice: any) => selectedDevice.did === device.did),
    }));
    setAssignedDevices(updatedDevices);
  }, [selectedDevices]);
  return (
    <div>
      <div className="card">
        <h3>{t("available_devices")}</h3>
        <Toast ref={toast} />
        <DataTable value={availableDevices} responsiveLayout="scroll">
          <Column field="did" header={t("device_id")}></Column>
          <Column field="rent_from" header={t("renting_from")}></Column>
          <Column field="rent_to" header={t("renting_to")}></Column>
          <Column body={buttonsTemplate} header={t("options")} />
        </DataTable>
      </div>

      <Dialog
        header={t("new_station_name")}
        visible={dialogue}
        style={{ width: "30vw" }}
        footer={renderFooter()}
        onHide={() => onHide()}
      >
        <div className="col-lg-12 text-center">
          <h5>{t("station_name")}</h5>
          <InputText
            value={stationName}
            onChange={(e) => setStationName(e.target.value)}
          />
        </div>
        <span className="text-center error-message">{error}</span>
      </Dialog>
      <p className="error-message">{error["no_device"]}</p>
      <div className="card">
        <h3>{t("assigned_device")}</h3>
        <DataTable value={assignedDevices} selection={selectedDevices} onSelectionChange={(e) => handleSelectionChange(e)}
                   dataKey="id">
          <Column field="did" header={t("device_id")}></Column>
          <Column field="station_name" header={t("station_name")}></Column>
          <Column field="rent_from" header={t("renting_from")}></Column>
          <Column field="rent_to" header={t("renting_to")}></Column>
          <Column body={buttons1Template} header={t("options")} />
          <Column selectionMode="multiple" header={t('settings')} headerClassName="custom-checkbox-header"></Column>

        </DataTable>
      </div>

      <div className="card">
        <div className="flex flex-wrap align-items-center justify-content-center lg:justify-content-between">
          <p className="text-danger text-underline">{t("attention")}:</p>
          <p
            style={{ maxWidth: "600px", fontWeight: "500" }}
            className="text-danger"
          >
            {t("attention_message")}
          </p>
          <div>
            <Button
              label={t("abort")}
              className="p-button-outlined p-button-secondary"
              onClick={()=>{
                showSuccess(
                    t('project_cancelled')
                );
                deleteProjectInfo()
                props.onNext();
              }}
            />
            <Button
              label={t("save")}
              className="p-button-outlined p-button-secondary ml-3"
              loading={disabled}
              onClick={() => {
                setError([]);
                setDisabled(true)
                createProjectService.createProjects(props.userId, assignedDevices, selectedDevices)
                    .then((response) => {
                      if (response.status === 200) {
                        showSuccess(t('project_created'));
                        deleteProjectInfo();
                        props.onNext();
                      }
                    });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default AssignDevices;
